import React from 'react';
import './TigerPawButton.css';

export const TigerPawButton = () => {
  return (
    <div className="tiger-paw">
      <svg 
        viewBox="0 0 100 100" 
        width="40" 
        height="40"
        fill="#D4AF37"
      >
        <path d="M50 5C45 5 40 10 40 15C40 20 45 25 50 25C55 25 60 20 60 15C60 10 55 5 50 5Z"/>
        <path d="M30 20C25 20 20 25 20 30C20 35 25 40 30 40C35 40 40 35 40 30C40 25 35 20 30 20Z"/>
        <path d="M70 20C65 20 60 25 60 30C60 35 65 40 70 40C75 40 80 35 80 30C80 25 75 20 70 20Z"/>
        <path d="M25 45C20 45 15 50 15 55C15 60 20 65 25 65C30 65 35 60 35 55C35 50 30 45 25 45Z"/>
        <path d="M75 45C70 45 65 50 65 55C65 60 70 65 75 65C80 65 85 60 85 55C85 50 80 45 75 45Z"/>
        <path d="M50 35C35 35 25 50 25 65C25 80 35 95 50 95C65 95 75 80 75 65C75 50 65 35 50 35Z"/>
      </svg>
    </div>
  );
};